import React from 'react';
import { Link } from 'react-scroll';

import Marquee from "react-fast-marquee";

const About = () => {
  return (
    <>


<Marquee className="text-4xl mx-4 py-6" pauseOnHover="true">
<a href="CRSU-HLA-Workshop.pdf" target="_blank">
                    <button
                      className="text-center rounded-lg px-4 py-3 m-2
                       bg-white text-gray-700 font-bold text-lg"
                    >
                      {/* International Conference on Reimagining Smart Libraries Emerging Technologies, Innovation and Knowledge Creation (May 10-11, 2024) Organized by IILM University, Gurugram & Haryana Library Association
                       */}
                        ONE WEEK ONLINE NATIONAL WORKSHOP ON LIBRARY AUTOMATION AND DIGITIZATION (11-16 June, 2024)
                    </button>
                  </a>
</Marquee>


 {/* <div className="relative flex overflow-x-hidden">
  <div className="py-12 animate-marquee whitespace-nowrap">
  <Link target='_blank' to='seminar1.pdf'> <span className="text-4xl mx-4"> Marquee Item 1</span> </Link>
    <span className="text-4xl mx-4">Marquee Item 2</span>
    <span className="text-4xl mx-4">Marquee Item 3</span>
    <span className="text-4xl mx-4">Marquee Item 4</span>
    <span className="text-4xl mx-4">Marquee Item 5</span>
  </div>

  
</div> */}



    {/* // h-screen */}
    <div name='about' className='w-full  bg-[#162d4f] text-gray-300 py-24'>  
      <div className='flex flex-col justify-center items-center w-full h-full'>
        {/* <div className='max-w-[1200px] w-full grid grid-cols-2 gap-8'> */}
        <div className='max-w-[1200px] w-full'>
          <div className=' pb-8 pl-4 text-center'>
            <p className='text-4xl font-bold inline border-b-4 border-pink-600'>
              About HLA
            </p>
          </div>
          <div></div>
          </div>
          <div className='max-w-[1200px] w-full grid sm:grid-cols-2 gap-8 px-4'>
            <div className='sm:text-right text-4xl font-bold'>
              <p>HLA is the largest and the most renowned professional association in the field of Library and Information Science in Hayana consisting of more than 500 members.</p>
            </div>
            <div>
              <p>It is a professional body which was formed in the year 1966. The first President of the Association was Mr. M. L. Bhagi, State Librarian, Haryana. The Association conducted a certificate course in the library science of 6 month’s duration form 1972-77. It arranged book exhibition as well. Mr. K. S. Dala took over as President in 1976. The entire constitution of the Association was re-framed, and the Association remained concern with improvement of library services, library profession and Library Science teaching in the State of Haryana. The first Haryana Library conference held at Kurukshetra University, Kurukshetra. The HLA is the largest and the most renowned professional association in the field of Library and Information Science in Hayana consisting of 320 members. 
The main objectives of the association are:<br/>
•	To improve the service in public, government  and institutional libraries in the Haryana state;<br/>
•	To improve working conditions and welfare of personnel engaged in libraries of the state.<br/>
•	To promoting library movement in Haryana;<br/>
•	To promote and improve library science training in Haryana and also to organize seminars, conference etc. to generate library consciousness in Haryana.<br/>
The Association was registered in the year 1978. It started publishing a bi-annual Newsletter since 1980. The Association submitted a Draft Model to the government for enactment of Library Legislation in the state of Haryana during 1988 that led to framing of the Public Library Act in the State.
</p>  
            </div>
          </div>
      </div>
    </div>
    </>
  );
 
};

export default About;
